export const GET_COST_OPTIMIZATION_RECOMMENDATIONS = `
  query GetCostOptimizationRecommendations($params: CostOptimizationParams!) {
    getCostOptimizationRecommendations(params: $params) {
      data {
        recommendation_id
        element
        account
        recommendation_type
        status
        potential_savings
        description
        created_date
        priority
        category
        resource_id
        region
        service
        last_refresh_timestamp
        last_seen_date
      }
      summary {
        total_recommendations
        total_potential_savings
        average_savings_per_recommendation
        status_breakdown {
          status
          count
          total_savings
        }
        category_breakdown {
          category
          count
          total_savings
        }
        priority_breakdown {
          priority
          count
          total_savings
        }
      }
      error {
        statusCode
        message
        code
      }
    }
  }
`
